import formatDecimal from "./formatDecimal";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-format/src/exponent.js
// module id = 38
// module chunks = 0 1 2 3 4